import React from 'react'
import {cx} from '@emotion/css'
import styled from '@emotion/styled'
import {ColorPath, Size} from 'types/Theme'

import * as iconsList from '@vio/atlas-assets/web/icons'

import {getCssColorByPath} from '../../../utils/colors'

export type IconSize = Exclude<Size, 'xxl'>

export type IconName = keyof typeof iconsList

interface Props {
  /** Pass through classname to allow styles overrides */
  className?: string
  /** Specify the color path from the theme's colors file to explicitly set the Icon's color */
  colorPath?: ColorPath
  /** The name of the custom icon that should be retrieved and rendered */
  name: IconName
  /** The size of the component */
  size?: IconSize
  /** Specifies if the icon is mirrored on RTL */
  hasMirror?: boolean
}

export const Wrapper = styled.div`
  display: flex;

  &.--mirror-icon {
    [dir='rtl'] & {
      transform: scaleX(-1);
    }
  }
`

export const iconSizeMap = {
  xs: 12,
  sm: 16,
  md: 20,
  lg: 24,
  xl: 32
}

export const Icon = ({
  name,
  colorPath,
  size = 'md',
  className,
  hasMirror = false
}: Props) => {
  const color = colorPath ? getCssColorByPath(colorPath) : 'currentColor'
  const IconElement = iconsList[name]

  if (!IconElement) return null

  return (
    <Wrapper className={cx(className, hasMirror && '--mirror-icon')}>
      <IconElement color={color} size={iconSizeMap[size]} />
    </Wrapper>
  )
}

export * as iconsList from '@vio/atlas-assets'
